import {useChaport} from 'src/hooks/use-chaport';

// данные авторизованного пользователя живут в redux, поэтому виджет
// подключается изнутри Provider, а не в App
export default function Chaport() {
  useChaport()

  return null;
}
